import React from 'react';
import { palette } from '../global/palette';
import { typography } from '../global/typography';
import Success from '@tdcerhverv/parrotfish/icons/Success';
import Error from '@tdcerhverv/parrotfish/icons/Error';
import Warning from '@tdcerhverv/parrotfish/icons/Warning';
import Info from '@tdcerhverv/parrotfish/icons/Info';
import { shape } from '../global/shape';
export const MuiAlert = {
    MuiAlert: {
        styleOverrides: {
            standardSuccess: {
                backgroundColor: palette.success.contrastText,
            },
            standardError: {
                backgroundColor: palette.error.contrastText,
            },
            standardInfo: {
                backgroundColor: palette.info.contrastText,
            },
            standardWarning: {
                backgroundColor: palette.warning.contrastText,
            },
            root: {
                padding: '8px 16px',
                borderRadius: 0,
            },
            icon: {
                padding: '8px 0',
                marginRight: 16,
                '& > svg': {
                    width: 24,
                    height: 24,
                },
            },
            message: Object.assign(Object.assign({}, typography.body2), { color: palette.common.black, display: 'flex', alignItems: 'flex-start', flexDirection: 'column', justifyContent: 'center', '& .MuiLink-root': Object.assign(Object.assign({}, typography.body2), { color: palette.common.black, display: 'contents', fontWeight: 'bold' }) }),
            action: {
                padding: '8px 0 0 16px',
                marginRight: 0,
                '& .MuiIconButton-root': {
                    padding: 0,
                    '& > svg': {
                        width: 14,
                        height: 14,
                    },
                },
            },
        },
        defaultProps: {
            iconMapping: {
                success: React.createElement(Success, { fill: palette.success.dark }),
                error: React.createElement(Error, { fill: palette.error.dark }),
                warning: React.createElement(Warning, { fill: palette.warning.dark }),
                info: React.createElement(Info, { fill: palette.info.dark }),
            },
        },
        variants: [
            {
                props: { variant: 'inline', severity: 'success' },
                style: Object.assign(Object.assign({ padding: `4px 12px`, backgroundColor: palette.success.contrastText, borderBottom: `3px solid ${palette.success.dark}` }, shape), { '& .MuiAlert-icon': {
                        color: palette.success.dark,
                    }, '& .MuiAlert-message': {
                        color: palette.success.dark,
                        '& .MuiAlertTitle-root': Object.assign(Object.assign({}, typography.subtitle2), { marginBottom: 0 }),
                        '& .MuiLink-root': {
                            color: palette.success.dark,
                        },
                    }, '& .MuiAlert-action': {
                        color: palette.success.dark,
                    } }),
            },
            {
                props: { variant: 'inline', severity: 'error' },
                style: Object.assign(Object.assign({ padding: `4px 12px`, backgroundColor: palette.error.contrastText, borderBottom: `3px solid ${palette.error.dark}` }, shape), { '& .MuiAlert-icon': {
                        color: palette.error.dark,
                    }, '& .MuiAlert-message': {
                        color: palette.error.dark,
                        '& .MuiAlertTitle-root': Object.assign(Object.assign({}, typography.subtitle2), { marginBottom: 0 }),
                        '& .MuiLink-root': {
                            color: palette.error.dark,
                        },
                    }, '& .MuiAlert-action': {
                        color: palette.error.dark,
                    } }),
            },
            {
                props: { variant: 'inline', severity: 'warning' },
                style: Object.assign(Object.assign({ padding: `4px 12px`, backgroundColor: palette.warning.contrastText, borderBottom: `3px solid ${palette.warning.dark}` }, shape), { '& .MuiAlert-icon': {
                        color: palette.warning.dark,
                    }, '& .MuiAlert-message': {
                        color: palette.warning.dark,
                        '& .MuiAlertTitle-root': Object.assign(Object.assign({}, typography.subtitle2), { marginBottom: 0 }),
                        '& .MuiLink-root': {
                            color: palette.warning.dark,
                        },
                    }, '& .MuiAlert-action': {
                        color: palette.warning.dark,
                    } }),
            },
            {
                props: { variant: 'inline', severity: 'info' },
                style: Object.assign(Object.assign({ padding: `4px 12px`, backgroundColor: palette.info.contrastText, borderBottom: `3px solid ${palette.info.dark}` }, shape), { '& .MuiAlert-icon': {
                        color: palette.info.dark,
                    }, '& .MuiAlert-message': {
                        color: palette.info.dark,
                        '& .MuiAlertTitle-root': Object.assign(Object.assign({}, typography.subtitle2), { marginBottom: 0 }),
                        '& .MuiLink-root': {
                            color: palette.info.dark,
                        },
                    }, '& .MuiAlert-action': {
                        color: palette.info.dark,
                    } }),
            },
        ],
    },
};
